<template>
  <div>
    <v-btn class="mx-auto" @click.stop="dialogAtivo = true" icon>
      <v-icon v-text="'mdi-alert'" />
    </v-btn>

    <sys-dialog v-model="dialogAtivo" titulo="Alerta" ocultar-acoes class="pb-5">
      <p>
        1 - Se a sugestão de compras for negativa e o item apresentar compra em trânsito
        <strong>"Previsão Futura em Excesso"</strong>
      </p>

      <p>
        2 - Se a sugestão de compras for zerada e o item apresentar compra em trânsito
        <strong>"Previsão Futura Adequada"</strong>
      </p>
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from "../../padraoDeLayout/SysDialog";
export default {
  name: "AlertaDeQtdSugestao",
  components: {SysDialog},
  data: () => ({
    dialogAtivo: false
  })
}
</script>

<style scoped>

</style>
